export interface AxiosResponse {
    data: any;
    status: number | string;
    message: string;
}

export interface SaleAngle {
    name: string,
    description: string
}

export interface FunnelPayload {
    products: any[],
    brand_name: string,
    sale_angles: SaleAngle[],
    free_shipping: boolean,
    warranties: number,
    template_design: {
        theme: string,
        primary_color: string,
        secondary_color: string
    },
    data_for_context: any
}

export interface AnalyticsFunnelPayload {
    owner_id: string;
    website_id: string;
    created_at: string;
}

export enum VideoStatus {
    INITIALIZING = "INITIALIZING",
    IN_PROGRESS = "IN_PROGRESS",
    DONE = "FINISHED",
    FAILED = "ERROR",
}